module.exports = __webpack_public_path__ + "static/media/tips.99e8b880.jpg";